import initSchemaLogger, { Logger } from '@wix/bi-logger-video-maker';
import webBiLogger from '@wix/web-bi-logger';
import { NoReturnTypeObject } from '../utils/types/noReturnType';

export const biLogger: NoReturnTypeObject<Logger> = initSchemaLogger(
  webBiLogger,
)();

interface IBiDefaults {
  msid: string;
  origin: string;
  source: string;
}

export const updateDefaultsBiLogger = (biDefaults: Partial<IBiDefaults>) => {
  biLogger.util.updateDefaults(biDefaults);
};
